export const VACATION_ADDED_ON_BEGINNING_OF_THE_YEAR_ID = "30030437-6cd7-4372-a42b-1e3310bbc062";

// Types of clocking events
export const TNA_CLOCKING_TYPES = {
  ClockIn: {
    id: "c5f79369-701e-4a36-95dd-489c7f69a317",
  },
  ClockOut: {
    id: "b0c5d7b9-d4ed-403b-a554-1a47852f05b2",
  },
};

export const HOW_TO_REPORT_TIME = {
  ClockingManually: {
    id: "96f508dc-df9a-458e-9e2a-052318eaaa4f",
  },
  AutoClockingBySytem: {
    id: "77aefd90-05a3-4e56-b695-ea60639720d8",
  },
  NoNeed: {
    id: "ddc926df-d87e-432c-baa1-a034875653af",
  },
  ManualWorkedHours: {
    id: "9fa7fdb1-55e3-4065-a516-26fcdccc0826",
  },
  AutoWorkedHours: {
    id: "b0303051-7dc7-4da4-bdff-e60b67e01f9c",
  },
  ManualWorkedDays: {
    id: "98c6fe8b-3513-4ac5-99e6-234b450463fa",
  },
  AutoWorkedDays: {
    id: "ade34d56-1818-460c-ba52-da075bcdbda6",
  },
};

export const BILLABLE_TIME_TYPE = {
  ON_SPECIFIC_PROJECT_LIST: {
    id: "52774710-1e1e-4662-b4eb-8fa63947bbd8",
  },
  ON_STANDARD_PROJECTS: {
    id: "5940b3f4-1672-4e90-af1f-c8b83e0951f2",
    name: "On standard projects",
  },
  NOT_ALLOWED: {
    id: "0964e792-dc5d-4197-836b-9521ed575eaa",
  },
};

export const CLOCKING_METHODS = {
  ONLY_IN_REAL_TIME: {
    //Allows only real time clocking buttons
    id: "0e0e6df2-1d51-427a-b496-59e563aac8d3",
    name: "Clocking allowed only in real time",
    code: "ORTC",
    description: "Clocking allowed only in real time",
  },
  ONLY_TODAY: {
    //Allows to add and change only clockings for today
    id: "c5fe30fd-41b9-4062-bca3-eb6376d8f54b",
    name: "Can add or change clocking for today only",
    code: "OFT",
    description: "Can add or change clocking for today only",
  },
  ANY_PERIOD: {
    //*DEFAULT* Allows to add / edit clocking at any time
    id: "81968ea3-2f31-4b97-9d26-c0902ca34a2e",
    name: "Can clock in or out for any time period",
    code: "ACFAP",
    description: "Can clock in or out for any time period",
  },
};

export const HOW_TO_HANDLE_MANDATORY_BREAK = {
  DO_NOTHING: {
    //*DEFAULT */
    id: "50ea7976-c409-456b-a56e-f8300ba59490",
    name: "Do nothing",
    code: "NTH",
    description: "Do nothing",
  },
  FLAG_AS_ANOMALY: {
    id: "1f7d8c49-0954-4bc9-a28f-88a55db7ccd1",
    name: "Flag as anomaly",
    code: "AAN",
    description: "Flag as anomaly",
  },
  INSERT_AUTOMATICALLY: {
    id: "69639b0f-f0e2-414a-ba30-6256dcef142a",
    name: "Insert automatically",
    code: "AUTO-B",
    description: "Insert automatically",
  },
};
